import React from 'react';
import { observer } from 'mobx-react';
import { FacilityInventoryCountDetailEditTemplate } from 'themes/application/facility-inventory/pages';
import { setCurrentView } from 'core/utils';
import { FacilityInventoryCountDetailEditViewStore } from 'application/facility-inventory/stores';

@setCurrentView((rootStore, componentProps) => new FacilityInventoryCountDetailEditViewStore(rootStore, componentProps), "facilityInventoryCountDetailEditViewStore")
@observer
class FacilityInventoryCountDetailEdit extends React.Component {
    render() {
        return <FacilityInventoryCountDetailEditTemplate {...this.props} />
    }
}

export default FacilityInventoryCountDetailEdit;